<template>
    <div id = "bar">
        <h1>KMMF</h1>
        <p>{{ $translation.L('FACULTY_OF_PHYSICS') }}</p>
        <p>{{ $translation.L('INFO_BAR_LINE_2') }}</p>
        <p>e-mail: kmmfsekr@fuw.edu.pl</p>
        <p>tel. 225532951</p>
        <p class="lang">
          <a v-if="currentLanguage === 'pl'" @click="en">English</a>
          <a v-else-if="currentLanguage === 'en'" @click="pl">Polish</a>
        </p>
    </div>
</template>

<script>
export default {
  name: 'infoBar',

  data() {
    return {
      currentLanguage: this.$translation.currentLanguage,
    };
  },

  methods: {
    en() {
      this.$translation.setLanguage('en');
      this.rerender();
    },

    pl() {
      this.$translation.setLanguage('pl');
      this.rerender();
    },

    rerender() {
      this.$emit('reload');
    },
  },
};
</script>

<style scoped>
#bar {
  text-align: center;
  background-color: #4d5499;
  color: white;
  padding: 10px;
  margin-top: 20px;
  margin-bottom: 25px;
  height: 40vw;
  -webkit-box-shadow: 9px 9px 80px -9px rgba(0,0,0,0.75);
  -moz-box-shadow: 9px 9px 90px -9px rgba(0,0,0,0.75);
  box-shadow: 9px 9px 80px -9px rgba(0,0,0,0.75);
  font-size: 4vw;
}

a {
  cursor: pointer;
}

.lang {
  width: 20vw;
  margin-right: 70vw;
  font-size: 3.0vw;
}

.lang a {
  text-decoration: underline;
  color: #ccc;
  user-select: none;
  transition: color 0.3s ease-in-out;
}

.lang a:hover {
  color: #fff;
}

@media only screen and (min-width: 1000px) {
  #bar {
    height: 10vw;
    font-size: 1.3vw;
  }

  .lang {
    width: 20vw;
    margin-right: 70vw;
    font-size: 0.8vw;
    margin-top: -1.5vw;
  }
}
</style>
